/* eslint-disable no-underscore-dangle */
import type { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleCheckResult } from '../../../src/app/@shared-types/vehicle/check';
import { Vehicle } from '../../../src/app/shared/models/vehicle/vehicle';

/* @ngInject */
export default class FormWrapController {
  public vehicle!: AutoboardVehicle;

  public overlay!: { action: string };

  public dummyVehicle!: boolean;

  private vehicleModel: Vehicle;

  public loadForm = false;

  public onlineCheck: VehicleCheckResult | null = null;

  constructor(
    vehicle: Vehicle,
  ) {
    this.vehicleModel = vehicle;
  }

  private preCheckNecessary = (): boolean => {
    switch (this.overlay.action) {
      case 'offer': return true;

      default: return false;
    }
  };

  async $onInit(): Promise<void> {
    if (!this.preCheckNecessary()) {
      this.loadForm = true;
      return;
    }

    const check = await this.vehicleModel.onlineCheck(String(this.vehicle._id), this.dummyVehicle);

    if (!check.error) {
      this.loadForm = true;
      return;
    }

    this.onlineCheck = check;
  }
}
